import styled from 'styled-components';

export const CancelBlockWrapper = styled.div`
  color: #a0a0a7;
  font-size: 15px;
  font-weight: 400;
  line-height: 30px;
  margin-top: 17px;
`;
